import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";


import ExpireBadge from "../ExpireBadge";
import FutureBadge from "../FutureBadge";

import styles from "./styles";

const AssetBaseInfo = ({classes, icon, subCategoryName, assetName, expiredAt, isFuture}) => (
  <>
    <Grid item xs={'auto'} className={classes.iconContainer}>{icon}</Grid>
    <Grid item xs={true} className={classes.namesContainer}>
      <Grid container>
        <Grid item xs={12} data-id={'category-name'}>
          <Grid container>
            <Grid item className={classes.subCategoryName}>{subCategoryName}</Grid>
            {!!expiredAt && <ExpireBadge expiredAt={expiredAt} />}
            {!!isFuture && <FutureBadge />}
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.assetName} data-id={'asset-name'}>{assetName}</Grid>
      </Grid>
    </Grid>
  </>
);

export default withStyles(styles)(AssetBaseInfo);
